define('lib/validator/ValidatorEmail',['require','lib/validator/ValidatorAbstract'],function (require) {

	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	
	return ValidatorAbstract.extend({
		
		/**
		 * Validates value
		 *  
		 * @param mixed value
		 */
		validate: function (value) {
			var regexp = /\S+@\S+\.\S+/;
			if (!_.isEmpty(value) && !regexp.test(value)) {
				this.addError('error_value_is_not_email');
			}
		}
	
	});
	
});
